var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.name.length > 17)?_c('span',[_vm._v(_vm._s(_vm.name.substr(0, 17))+"...")]):_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }